/**
 * Topic strings for corpus naming from a Langchain run payload (member poll / HITL).
 *
 * Precedence aligns with ``resolve_search_topic`` in
 * ``python_langchain_executor/app/workflows/deep_web_search/state.py``:
 * prefer refined / search-oriented strings, then AI one-line summary, then raw topic.
 *
 * @param {object|null|undefined} runPayload — shape like ``{ input: {}, output: {} }``
 * @returns {{ topicLabel: string, aiSummary: string, suggestApiPayload: object }}
 */
export function deriveTopicHintsFromRunPayload(runPayload) {
  const input = runPayload && typeof runPayload.input === "object" ? runPayload.input : {}
  const output = runPayload && typeof runPayload.output === "object" ? runPayload.output : {}
  const au =
    output.ai_understanding && typeof output.ai_understanding === "object" ? output.ai_understanding : {}
  const oneLine = (au.one_line_summary != null ? String(au.one_line_summary) : "").trim()

  const topicRefined = (output.topic_refined != null ? String(output.topic_refined) : "").trim()
  const topicForSearch = (output.topic_for_search != null ? String(output.topic_for_search) : "").trim()
  const topicOut = (output.topic != null ? String(output.topic) : "").trim()
  const topicIn = (input.topic != null ? String(input.topic) : "").trim()

  const topicLabel = topicRefined || topicForSearch || topicOut || topicIn || ""
  const aiSummary = oneLine

  return {
    topicLabel,
    aiSummary,
    suggestApiPayload: {
      one_line_summary: oneLine || undefined,
      topic_refined: topicRefined || undefined,
      topic_for_search: topicForSearch || undefined,
      topic: topicLabel || topicIn || undefined,
    },
  }
}
